import { useSelector } from 'react-redux';
import {
  EmergencyLocation,
  EmergencyCallLocation,
  EmergencyCallSecondaryLocation,
} from './emergencyCalls.types';
import { EmergencyCallsState } from './emergencyCallsSlice';

/**
 * Determines if a call status should be updated in the unlikely event where the ALI location
 * payload from Hermes is not in order.
 * @param {Object} previousLocation - most recent location payload
 * @param {Object} currentLocation - current ALI location payload
 * @returns Boolean
 */
export const shouldUpdateCallStatus = (
  previousLocation: EmergencyLocation | EmergencyCallSecondaryLocation,
  currentLocation: EmergencyLocation | EmergencyCallSecondaryLocation,
) => {
  return (
    !!(
      !previousLocation &&
      currentLocation &&
      'call_status' in currentLocation &&
      currentLocation?.call_status
    ) ||
    !!(
      previousLocation &&
      currentLocation &&
      'call_status' in currentLocation &&
      currentLocation?.call_status &&
      currentLocation.created_time > previousLocation.created_time
    )
  );
};

export const useGetSelectedCollaborator = () => {
  const selectedCallerID = useSelector(
    (state: { emergencyCalls: EmergencyCallsState }) =>
      state.emergencyCalls.selectedCallerID,
  );

  const collaborator = useSelector(
    (state: { emergencyCalls: EmergencyCallsState }) => {
      if (!selectedCallerID) {
        return null;
      }
      return state.emergencyCalls.callQueue[selectedCallerID]?.collaborator;
    },
  );

  return (
    collaborator || {
      conversationID: null,
      pairedAccountID: null,
      type: null,
      isUnread: false,
      pairedAccountName: null,
      dispatcherPosition: null,
    }
  );
};

export const isEmergencyCallLocation = (
  location: EmergencyLocation,
): location is EmergencyCallLocation => {
  return (
    Object.hasOwnProperty.call(location, 'latitude') &&
    Object.hasOwnProperty.call(location, 'longitude')
  );
};
